/*
 * @Author: Ryan
 * @Date: 2025-12-04
 * @Description: 静音/取消静音切换按钮组件 - SEO版本
 */
import React from 'react';

interface MuteToggleProps {
  isMuted: boolean;
  onToggle: () => void;
}

const MuteToggle: React.FC<MuteToggleProps> = ({ isMuted, onToggle }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="absolute top-3 left-3 z-9 w-[43px] h-[43px] rounded-full bg-white/30 hover:bg-white/40 flex items-center justify-center transition-all duration-300 shadow-lg"
      aria-label={isMuted ? 'Unmute' : 'Mute'}
      style={{
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
      }}
    >
      {isMuted ? (
        // Muted icon - Frame (3).svg
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="drop-shadow-md"
        >
          <g clipPath="url(#clip0_431_570)">
            <path
              d="M12 5.625C12.2337 5.83369 12.4455 6.06739 12.6315 6.32205C13.177 7.0689 13.5 7.99586 13.5 9C13.5 9.99544 13.1826 10.915 12.6457 11.6585C12.4563 11.9207 12.2397 12.161 12 12.375"
              stroke="white"
              strokeWidth="1.51826"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.8386 15.4447C15.0315 14.1358 16.5002 11.7394 16.5002 9.00004C16.5002 6.30323 15.0768 3.93885 12.9403 2.61719"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <line
              x1="0.797773"
              y1="0.842416"
              x2="13.1728"
              y2="17.1549"
              stroke="white"
              strokeWidth="1.1387"
            />
            <path
              d="M9.75854 15.4946V15.7495C9.75854 16.1688 9.41901 16.5083 8.99976 16.5083C7.36381 16.5082 6.0305 15.4522 5.17749 14.5542C4.73634 14.0897 4.38546 13.6288 4.14624 13.2847C4.09401 13.2095 4.04953 13.1372 4.00757 13.0737H2.24976C1.41641 13.0736 0.740967 12.3974 0.740967 11.564V6.37842C0.74114 5.74185 1.13549 5.19768 1.69312 4.97607L9.75854 15.4946ZM8.99976 1.49072C9.41892 1.49072 9.7584 1.83038 9.75854 2.24951V13.6245L3.04663 4.86963H4.01147C4.05344 4.80715 4.09793 4.73649 4.15015 4.6626C4.3897 4.32364 4.73974 3.86898 5.1814 3.41162C6.03621 2.52642 7.36879 1.49083 8.99976 1.49072Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_431_570">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        // Unmuted icon - Frame (4).svg
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="drop-shadow-md"
        >
          <path
            d="M9.42468 2.35547V16.4925C6.67582 16.4925 4.63323 12.895 4.63323 12.895H2.35619C1.92243 12.895 1.5708 12.5434 1.5708 12.1096V6.67934C1.5708 6.24557 1.92243 5.89396 2.35619 5.89396H4.63323C4.63323 5.89396 6.67582 2.35547 9.42468 2.35547Z"
            fill="white"
            stroke="white"
            strokeWidth="1.57078"
            strokeLinejoin="round"
          />
          <path
            d="M12.5662 5.89111C12.8109 6.10965 13.0327 6.35437 13.2275 6.62105C13.7987 7.40314 14.1369 8.37384 14.1369 9.42536C14.1369 10.4678 13.8045 11.4307 13.2423 12.2093C13.044 12.4839 12.8171 12.7355 12.5662 12.9596"
            stroke="white"
            strokeWidth="1.57078"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.4448 16.1744C15.7412 14.8038 17.2791 12.2944 17.2791 9.42572C17.2791 6.60166 15.7886 4.12573 13.5513 2.7417"
            stroke="white"
            strokeWidth="1.57078"
            strokeLinecap="round"
          />
        </svg>
      )}
    </button>
  );
};

export default MuteToggle;
